import React from 'react';
import { getAgentResponse, getAgentResponseText } from '../../../AlmeResponse/AlmeResponse';
import { AgentCardBubbleContent, AgentCardContainer, AgentCardMessageContainer } from '../../../AlmeResponse/AlmeResponse.styles';
import { AgentCardBubble } from '../../../AlmeResponse/ChatBubble';
import LiveChatIcon from '../../../AlmeUtilities/Icons/LivechatIcon';
export function isValidLiveChatSystemResponse(response, isLastResponse) {
    var _a, _b, _c;
    const responseText = getAgentResponseText(response);
    const hasIvaResponse = !!(responseText);
    return hasIvaResponse && (((_a = response === null || response === void 0 ? void 0 : response.extensionData) === null || _a === void 0 ? void 0 : _a.MessageOrigin) === 'System') &&
        (((_b = response === null || response === void 0 ? void 0 : response.extensionData) === null || _b === void 0 ? void 0 : _b.Transient) === false || (((_c = response === null || response === void 0 ? void 0 : response.extensionData) === null || _c === void 0 ? void 0 : _c.Transient) === true && isLastResponse));
}
const AlmeLiveChatSystemResponse = (props) => {
    const response = Object.assign(Object.assign({}, props.response), { html: '' });
    if (!isValidLiveChatSystemResponse(props.response, props.isLastResponse)) {
        return null;
    }
    const responseText = getAgentResponse(response);
    const responseRevision = (props.responseId || response.responseRevision).toString();
    const entryId = response.extensionData.entryId || responseRevision;
    return (React.createElement(AgentCardContainer, { id: `alme-system-live-chat-card-${responseRevision}`, key: `${entryId}-system` },
        React.createElement(LiveChatIcon, { size: 40, alt: "Live Agent", "aria-labelledby": "Live Agent" }),
        React.createElement(AgentCardMessageContainer, null,
            React.createElement(AgentCardBubble, null,
                React.createElement(AgentCardBubbleContent, null, responseText)))));
};
export default AlmeLiveChatSystemResponse;
